import API from '..';
const ENTITY = 'dashboards';

export const getProjectsSalesStage = () =>
    API.get(`/api/v1/${ENTITY}/projects_sales_stage/`);
